import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import * as Styled from './ProgressBar.styled';

/**
 * Displays a visual indication of progress based on a percent complete
 */
const ProgressBar = ({ fillPercent, ...props }) => {
  const [loaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <Styled.ProgressBar {...props}>
      <Styled.Fill fillPercent={Math.min(100, fillPercent)} loaded={loaded} />
    </Styled.ProgressBar>
  );
};

ProgressBar.propTypes = {
  /**
   * percent the progress bar is filled, capped at 100
   */
  fillPercent: PropTypes.number
};

ProgressBar.defaultProps = {
  fillPercent: 0
};

export default ProgressBar;
